var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed top-0 left-0 z-40 w-screen h-screen bg-gray-900 bg-opacity-60 flex flex-col justify-center items-center"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }